import { useEffect, useId, useRef } from "react";

declare global {
  interface Window {
    turnstile?: {
      render: (
        element: HTMLElement,
        options: {
          sitekey: string;
          callback: (token: string) => void;
          "expired-callback": () => void;
          theme?: string;
        },
      ) => string;
      remove: (widgetId: string) => void;
    };
  }
}

export function TurnstileWidget({
  siteKey,
  onToken,
  theme = "light",
}: {
  siteKey: string;
  onToken: (token: string) => void;
  theme?: "light" | "dark";
}) {
  const ref = useRef<HTMLDivElement>(null);
  const reactId = useId();
  useEffect(() => {
    if (!siteKey) {
      onToken("local-development");
      return;
    }
    let widgetId: string | undefined;
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (window.turnstile && ref.current) {
        window.clearInterval(timer);
        widgetId = window.turnstile.render(ref.current, {
          sitekey: siteKey,
          callback: onToken,
          "expired-callback": () => onToken(""),
          theme,
        });
      } else if (attempts > 40) {
        window.clearInterval(timer);
      }
    }, 100);
    return () => {
      window.clearInterval(timer);
      if (widgetId && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [siteKey, onToken, theme]);
  return (
    <div id={`turnstile-${reactId.replaceAll(":", "")}`} ref={ref} className="turnstile-slot" />
  );
}
